var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useForm } from "react-hook-form";
import { AuthButton, Form, InputField } from "peggirkit";
import { requestPasswordReset } from "serpotrack-connector";
var AuthFormResetPassword = function () {
    var intl = useIntl();
    var _a = useForm(), register = _a.register, getValues = _a.getValues, handleSubmit = _a.handleSubmit, errors = _a.formState.errors;
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useState(false), formDisabled = _c[0], setFormDisabled = _c[1];
    var _d = useState(null), formError = _d[0], setFormError = _d[1];
    var _e = useState(null), formSuccess = _e[0], setFormSuccess = _e[1];
    useEffect(function () {
        if (!loading) {
            return;
        }
        var submittedData = getValues();
        requestPasswordReset(submittedData.emailAddress).then(function () {
            setFormSuccess(intl.formatMessage({ id: "passwordResetRequested" }));
            setFormError(null);
            setLoading(false);
            setFormDisabled(true);
        }).catch(function () {
            setFormSuccess(null);
            setFormError(intl.formatMessage({ id: "errorRequestingPasswordReset" }));
            setLoading(false);
        });
    }, [loading]);
    return (_jsxs(Form, __assign({ onSubmit: handleSubmit(function () { return setLoading(true); }), error: formError, success: formSuccess }, { children: [_jsx(InputField, { id: "emailAddress", displayName: intl.formatMessage({ id: "emailAddress" }), type: "email", placeholder: intl.formatMessage({ id: "emailAddress.placeholder" }), tip: intl.formatMessage({ id: "existingRegisteredEmail" }), disabled: loading || formDisabled, error: errors.emailAddress && errors.emailAddress.message, reactHookForm: __assign({}, register("emailAddress", {
                    required: intl.formatMessage({ id: "enterEmailAddress" }),
                    minLength: {
                        value: 3,
                        message: intl.formatMessage({ id: "mustContainAtLeastCharacters" }, { min: 3 })
                    },
                    maxLength: {
                        value: 128,
                        message: intl.formatMessage({ id: "canContainAtMostCharacters" }, { max: 128 })
                    }
                })) }), _jsx(AuthButton, { disabled: loading || formDisabled, loading: loading, text: intl.formatMessage({ id: "reset" }) })] })));
};
export default AuthFormResetPassword;
